module.exports = __webpack_public_path__ + "assets/img/jyx1.9f3cd743.png";